import React, { useContext } from 'react';
import { Desplegable } from './Desplegable';
import { HOME_DESPLEGABLE_TITLE, HOME_DESPLEGABLE_TEXT } from '../shared/Constantes';
import { VStack } from '@bpba/ui-components';
import { StyledSpan } from '../shared/StyledSpan';
import { StyledButton } from '../shared/StyledButton';
import {} from '../shared/Constantes';
import { useNavigate } from 'react-router-dom';
import { StatusContext } from '../shared/Layout';

export const Descripcion = () => {
  const navigate = useNavigate();
  const appStatus = useContext(StatusContext);

  const messageHome = appStatus?.messageHome ?? '';
  const message = appStatus?.message ?? '';

  const getMessage = () => {
    return appStatus?.availableService ? messageHome : message;
  };

  return (
    <VStack color={'white'}>
      <StyledSpan fontSize={['22px', '25px']} lineHeight={['30px', '36px']} marginBottom={['50px']} marginTop={['24px', '0px']}>
        <div dangerouslySetInnerHTML={{ __html: getMessage() }} />
      </StyledSpan>
      {appStatus?.availableService === true && (
        <StyledButton width={['100%']} marginBottom={'50px'} onClick={() => navigate('/canje')}>
          Obtené tus entradas
        </StyledButton>
      )}
      <Desplegable title={HOME_DESPLEGABLE_TITLE} text={HOME_DESPLEGABLE_TEXT} />
    </VStack>
  );
};
